import CloudflareValidate from "components/tools/cloudflare";
import GoogleLogin from "components/tools/google";
import { useHttpUtil } from "context/HttpContext";
import { TipsType, useTipsContext } from "context/tips";
import { ChangeEvent, useEffect, useState } from "react";
import AuthButton from "../button";
import '../client.css'
import CustomImage from "components/common/CustomImage";
import Tools from "libs/utils/Tools";
import Config from "config/config";
import Stats from "libs/utils/stats";

type SigninForm = {
    email: string,
    password: string,
    code ?: string,
    token: string
}



export default function LoginClient(){
    const tipsContext = useTipsContext();
    const httpUtil = useHttpUtil();
    const [ signinFormData, setSigninFormData ]= useState<SigninForm>({
        email: '',
        password: '',
        code : '',
        token: ''
    })
    const [ emailValidateCode, setEmailValidateCode ] = useState<number>(0);
    const [ isShowPassword, setIsShowPassword ] = useState<boolean>(false)
    const [ resetValidateComp, setResetValidateComp ]= useState<number>(0);
    const [ isCommiting, setIsCommiting ]= useState<boolean>(false);
    const [ tip ,setTip ]= useState<string>();
    const [ emailErrTip, setEmailErrTip ]= useState<string>();
    const [ pwdErrTip, setPwdErrTip ]= useState<string>();
    const [ codeErrTip, setCodeErrTip ]= useState<string>();

    const enterSubmit = (e: KeyboardEvent) => {
        if(e.key && e.key.toLocaleLowerCase() === 'enter' || e.keyCode === 13){
            submit();
        }
    }

    useEffect(() => {
        document.body.addEventListener('keydown', enterSubmit)
        return () => {
            document.body.removeEventListener('keydown', enterSubmit)
        }
    },[signinFormData])

    useEffect(() => {
        const params = new URLSearchParams( window.location.search);
        const email = params.get('email'); 
        if(email){
            setSigninFormData({
                ...signinFormData,
                email : decodeURIComponent(email)
            })
        }
    },[])

    const changeEmail = (event: ChangeEvent<HTMLInputElement>) => {
        const email = event.target.value ;
        if(!email){
            setEmailErrTip('Email is required.')
        }else{
            setEmailErrTip('')
        }
        setSigninFormData({
            ...signinFormData,
            email
        })
    }

    const changeCode = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.value ;
        if(!code){
            setCodeErrTip('Password is required.')
        }else{
            setCodeErrTip('')
        }
        setSigninFormData({
            ...signinFormData,
            code
        })
    }

    const changePassword = (event: ChangeEvent<HTMLInputElement>) => {
        const password = event.target.value ;
        if(!password){
            setPwdErrTip('Verification code is required.')
        }else{
            setPwdErrTip('')
        }
        setSigninFormData({
            ...signinFormData,
            password
        })
    }

    const toggleShowPwd = () => {
        setIsShowPassword(!isShowPassword)
    }

    const changeToken = (token: string) => {
        // console.info('token', token)
        setTip('')
        setSigninFormData(fd => {
            return {
                ...fd, token
            }
        })
    }

    const submit = async () => {
        if(emailValidateCode == 0){
            validateEmail();
        }else{
            login();
        }
    }

    const validateEmail = async() => {
        if(isCommiting) return ;
        if(!signinFormData.token){
            return tipsContext?.show(TipsType.ERROR, 'Please finish the captcha first.')
        }
        let isPass = true ;
        if(!signinFormData.email){
            isPass = false ;
            setEmailErrTip('Email is required')
        }else if(!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+){1,}$/ig.test(signinFormData.email)){
            isPass = false ;
            setEmailErrTip('Email format is incorrect.')
        }
        setIsCommiting(true);
        const resData = await httpUtil.post('/api/auth/login', signinFormData)
        setIsCommiting(false);
        resetCFValidate();
        
        if(resData.errCode === 300){
            setEmailValidateCode(1);
            tipsContext?.show(TipsType.SUCCESS, 'The verification code has been sent to your email')
        }else if(resData.errCode == 0){
            setEmailValidateCode(2);
        }else if(resData.errCode === 202){
            setEmailErrTip(resData.errMsg);
            setTimeout(() => {
                location.href = Tools.disponseUrl('/signup?email=' + encodeURIComponent(signinFormData.email));
            },300)
            return
        }else{
            setEmailErrTip(resData.errMsg)
        }
    }
    
    const login = async () => {
        if(isCommiting) return ;
        if(!signinFormData.token){
            return tipsContext?.show(TipsType.ERROR, 'Please finish the captcha first.')
        }
        let isPass = true ;
        if(!signinFormData.email){
            isPass = false ;
            setEmailErrTip('Email is required')
        }else if(!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+){1,}$/ig.test(signinFormData.email)){
            isPass = false ;
            setEmailErrTip('Email format is incorrect.')
        }
        if(emailValidateCode == 1){
            if(!signinFormData.code){
                isPass = false ;
                setCodeErrTip('Verification code is required.')
            }
        }
        if(!signinFormData.password){
            isPass = false ;
            setPwdErrTip('Password is required.')
        }
        if(!isPass){
            return ;
        }
        setIsCommiting(true);
        const resData = await httpUtil.post('/api/auth/login', signinFormData)
        setIsCommiting(false);
        resetCFValidate();
        if(resData.errCode === 100 || resData.errCode === 101){
            return tipsContext?.show(TipsType.ERROR, 'Captcha verification error, please try again.')
        }
        if(resData.errCode === 300){
            return setEmailErrTip(resData.errMsg);
        }
        if(resData.errCode === 200){
            if(/verification/ig.test(resData.errMsg)) setCodeErrTip(resData.errMsg);
            else if(/password/ig.test(resData.errMsg)) setPwdErrTip(resData.errMsg);
        }
        if(resData.errCode){
            return tipsContext?.show(TipsType.ERROR, resData.errMsg);
        }else{
            location.href = Tools.disponseUrl(atob(resData.data)) + '&callback=' + encodeURIComponent(Config.platformUrl);
        }
    }

    
    const resetCFValidate = () => {
        setSigninFormData({
            ...signinFormData,
            token: ''
        })
        setResetValidateComp(new Date().getTime())
    }
    return (
        <div className={"i__0"}>
            <h3>Sign in</h3>
            <GoogleLogin className={"i__1"} />
            <div className={"i__2"}>
                <p>OR</p>
            </div>
            <div className={"i__3"}>
                <div className={"i__3__i" + ' ' + (emailErrTip ? "i__3__i__e" : '')}>
                    <label>Email</label>
                    <input type="text" placeholder="Email address" value={signinFormData?.email} onChange={(event: ChangeEvent<HTMLInputElement>) => changeEmail(event)}  />
                    {
                        emailErrTip && <p>{emailErrTip}</p>
                    }
                </div>
                {
                    emailValidateCode == 1 && 
                    <div className={"i__3__i" + ' ' + (codeErrTip ? "i__3__i__e" : '')}>
                        <label>Verification code</label>
                        <input type={'text'} placeholder="Verification code" value={signinFormData?.code} onChange={(event: ChangeEvent<HTMLInputElement>) => changeCode(event)}  />
                        {
                            codeErrTip && <p>{codeErrTip}</p>
                        }
                        <span onClick={validateEmail}>Resend</span>
                    </div>
                }
                {
                    emailValidateCode > 0 && 
                    <div className={"i__3__i" + ' ' + (pwdErrTip ? "i__3__i__e" : '')}>
                        <label>{ emailValidateCode == 1 ? 'Create Password' : 'Password'}</label>
                        <input type={isShowPassword ? 'text' : 'password'} placeholder="Password" value={signinFormData?.password} onChange={(event: ChangeEvent<HTMLInputElement>) => changePassword(event)}  />
                        <CustomImage src={isShowPassword ? '/icon/icon-pwd-hidden.png' : '/icon/icon-pwd-show.png'} onClick={toggleShowPwd} />
                        {
                            pwdErrTip && <p>{pwdErrTip}</p>
                        }
                    </div>
                }
                
                <p className={"i__3__q"}>Don't have an account yet? <a href={Config.routePrefix + "/signup"}>Sign up</a></p>
                <div className={"i__3__btn"}>
                    <AuthButton clickHandler={submit} isLoading={isCommiting} text={"Continue"} />
                </div >
                <p className={"i__3__t"}>By signing in you agree to <br/>our <a href="/termsofservice" target={"_blank"}>Terms of Service</a> and <a href="/privacy" target={"_blank"}>Privacy Policy</a>.</p>
            </div>
            <div className={"i__3__v"}>
                <div id="cf-validate"></div>
                {
                    tip && <p>{tip}</p>
                }
            </div>
            <CloudflareValidate tokenResponseHandle={changeToken} resetFlag={resetValidateComp} />
        </div>
    )
}